<template>
  <div class="row justify-content-center" style="">
    <div class="col-12 col-md-10 col-lg-8 col-xl-8">
      <div class="tit text-center">
        <h2>Endereço</h2>
      </div>
    </div>
    <address-form :address="address" @submit="handleSubmit"/>
  </div>
</template>

<script>
  import AddressForm from '@/components/AddressForm'

  export default {
    components: { AddressForm },
    props: {
      investor: {type: Object, required: true}
    },
    computed: {
      address: function() {
        const address = this.investor.Endereco || {}
        return {
          zipcode: address.Cep,
          neighborhood: address.Bairro,
          complement: address.Complemento,
          street: address.Logradouro,
          number: address.Numero,
          state: address.Uf,
          city: address.Cidade
        }
      }
    },
    methods: {
      handleSubmit(formData) {
        this.$emit('submit', {
          Endereco: {
            Cep: formData.zipcode,
            Bairro: formData.neighborhood,
            Complemento: formData.complement,
            Logradouro: formData.street,
            Numero: formData.number,
            Uf: formData.state,
            Cidade: formData.city
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationInvestor/PassoEndereco.vue